'use client';

import { useEffect } from 'react';
import { useSettings } from '@/providers/settings-provider';

export function ConditionalCSS() {
  const { settings } = useSettings();

  useEffect(() => {
    const layout = settings?.layout;

    // Entferne alle bestehenden theme-spezifischen CSS-Klassen
    document.body.classList.remove('metronic-pure', 'xoffi-enhanced');

    if (layout === 'metronic') {
      // Für Metronic Pure: Nur Standard Metronic CSS
      document.body.classList.add('metronic-pure');
      
      // Dynamisches Laden der Standard Metronic CSS (ohne XOFFI Übergriffe)
      if (!document.querySelector('#metronic-css')) {
        const link = document.createElement('link');
        link.id = 'metronic-css';
        link.rel = 'stylesheet';
        link.href = '/css/metronic-pure.css'; // Wir werden diese Datei erstellen
        document.head.appendChild(link);
      }
      
      // Entferne XOFFI CSS temporär
      const xoffiCSS = document.querySelector('#xoffi-css');
      if (xoffiCSS) {
        xoffiCSS.disabled = true;
      }
    } else {
      // Für alle anderen Themes: Standard XOFFI CSS
      document.body.classList.add('xoffi-enhanced');
      
      // XOFFI CSS wieder aktivieren
      const xoffiCSS = document.querySelector('#xoffi-css');
      if (xoffiCSS) {
        xoffiCSS.disabled = false;
      }
      
      // Entferne Metronic Pure CSS
      const metronicCSS = document.querySelector('#metronic-css');
      if (metronicCSS) {
        metronicCSS.remove();
      }
    }
  }, [settings?.layout]);

  return null; // Dieser Komponente rendert nichts
}

// Lade Standard XOFFI CSS statisch
import '@/css/styles.css'; 